// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6b478efd","724":"92af8f54"}[chunkId] + ".chunk.js";
};